import Logger from './Logger';

const DefaultLogger = new Logger();

export default DefaultLogger;
